import { useSelector } from 'react-redux';

export const useBranding = () => {
  const state = useSelector(({ branding }) => branding);
  return state;
};
